// extracted by mini-css-extract-plugin
module.exports = {"IconCheckbox":"styles_IconCheckbox__30Rmg","TableSelectCheckbox":"styles_TableSelectCheckbox__2eO8N","IconCheckbox__Input":"styles_IconCheckbox__Input__29_zo"};